import {
  DocumentTextIcon,
  InformationCircleIcon
} from '@heroicons/react/24/outline'

const solutions = [
    // { name: 'Aviso', description: 'Para mejorar tu experiencia en nuestra plataforma, estaremos actualizando los días 13 y 14 de septiembre, por lo que podrías experimentar intermitencia al ingresar al campus.', href: '#', icon: InformationCircleIcon },
    { name: 'Aviso', description: 'Debes comunicarte directamente a tu sede con el director.', href: '#', icon: InformationCircleIcon },
    /*
  { name: 'Engagement', description: 'Speak directly to your customers', href: '#', icon: CursorArrowRaysIcon },
  { name: 'Security', description: "Your customers' data will be safe and secure", href: '#', icon: FingerPrintIcon },
  { name: 'Integrations', description: 'Connect with third-party tools', href: '#', icon: SquaresPlusIcon },
  { name: 'Automations', description: 'Build strategic funnels that will convert', href: '#', icon: ArrowPathIcon },*/
]
const callsToAction = [
  //{ name: 'Colegiatura, Nivelación', href: '#', icon: BanknotesIcon},
  { name: 'Aceptar', href: '#', icon: DocumentTextIcon},
]

const Avisos = ({ setEstado }) => {
  return (

          <div className="w-screen max-w-xl flex-auto overflow-hidden rounded-3xl bg-primarioMira text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
            <div className="p-4">
              {solutions.map((item) => (
                <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-4 |hover:bg-gray-50">
                  <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-primarioMira |group-hover:bg-white">
                    <item.icon className="h-12 w-12 text-secundario " aria-hidden="true" />
                  </div>
                  <div>
                    <a href={item.href} className="font-semibold text-white text-2xl">
                      {item.name}
                      <span className="absolute inset-0" />
                    </a>
                    <p className="mt-1 text-gray-200 text-xl">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 divide-x divide-gray-900/5 bg-azulBrillanteMira hover:bg-secundario">
              {callsToAction.map((item, index) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={()=> setEstado(false)}
                  className="grid gap-x-2.5 p-3 font-semibold text-white mx-auto text-lg"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
  )
}

export default Avisos